import React, {Fragment} from 'react'
import List from '../../../../components/Project/Resources/FuelTokens/List'
import FuelTokenModal from '../../../../components/Project/Resources/FuelTokens/FuelTokensModal'

function FuelTokens(props) {
  return (
    <Fragment>
      <FuelTokenModal {...props} />
      <List {...props} />
    </Fragment>
  )
}

FuelTokens.propTypes = {}
FuelTokens.defaultProps = {}

export default FuelTokens
